export default __webpack_public_path__ + "static/media/Dewey-Panic-Grass_L3.4c5dc5ed.png";